var seedrandom = require('seedrandom');
var self = require('./shuffle-seed');

module.exports = self;




//////////////////
// WEBPACK FOOTER
// ./~/shuffle-seed/index.js
// module id = 157
// module chunks = 0